<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name: "userinfo",
    data() {
        return {
            isEdit: false,
            userinfo: {
                avatar: '',
                username: '阿斯顿啊是',
                phone: '15566668888',
                email: 'aaa@qq.com'
            },
            username: '',
            email: '',
            phone: '',
            code: '',
            isLoading: false,
            isCodeLoading: false,
            countdown: 0,
            time: null,
            isShowAvatarEdit: false,
            image: '',
            cropper: null,
            avatar: '',
        };
    },
    computed: {
        // ...mapState(['userinfo']),
    },
    components: {
        Loading
        
    },
    mounted() {
        this.username = this.userinfo.username;
        this.email = this.userinfo.email;
        this.phone = this.userinfo.phone;
    },
    destroyed() {},
    watch: {
        isShowAvatarEdit: {
            handler: function(val){
                if(val){
                    document.body.style.overflow = 'hidden';
                }else{
                    document.body.style.overflow = 'auto';
                }
            },
            immediate: true
        }
    },
    methods: {
        // 设置倒计时
        setCountdown() { 
            this.countdown = 3;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.phone,
                type: 1
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        // 修改
        submit() { 
            if (this.isLoading) {
                return;
            }
            if(this.username.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.username.focus();
                this.$showToast({ text: '请输入用户名' });
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' });
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            if(this.code.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.code.focus();
                this.$showToast({ text: '请输入验证码' });
                return false;
            }
            this.isLoading = true;
        },
        // 获取文件信息
        getFileData(){
            const file = this.$refs.file.files[0];
            // 读取文件
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (result) => { 
                this.image = reader.result;
            }
        },
        // 图片加载完成
        // cropper初始化
        cropperInit() {
            // 如果之前有，销毁
            if (this.cropper) this.cropper.destroy();
            // 构建实例
            this.cropper = new Cropper(this.$refs.image, {
                preview: this.$refs.preview,
                aspectRatio: 1,
                viewMode: 1,
                dragMode: 'move',
                cropBoxMovable: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
            });
        },
        // 保存头像
        uploadAvatar() { 
            const croppedCanvas = this.cropper.getCroppedCanvas({
                width: 300,
                height: 300
            });
            
            // base64
            // var croppedDataURL = croppedCanvas.toDataURL();
            // console.log(croppedDataURL);

            // 获取Blob对象
            croppedCanvas.toBlob((blob) => {
                // 上传
                let formData = new FormData();
                formData.append('image', blob);
                this.$store.dispatch('upImages', formData).then((result) => {
                    this.$showToast({ text: '上传成功' });
                    // 关闭弹窗并销毁裁剪器
                    this.closeAvatarEdit();
                }).catch((err) => {
                    this.$showToast({ text: '上传失败' });
                });;
            })
        },
        // 关闭弹窗
        closeAvatarEdit() { 
            this.isShowAvatarEdit = false;
            if (this.cropper) { 
                this.cropper.destroy();
                this.cropper = null;
            }
            this.image = '';
        },
    },
};
</script>

<template>
    <div class="userinfo">
        <p class="title">用户信息</p>
        <!-- 头像 -->
        <div class="avatar" @click="isShowAvatarEdit = true" v-if="userinfo && userinfo.avatar" :style="`background-image: url(${userinfo.avatar});`"></div>
        <div class="avatar default" @click="isShowAvatarEdit = true" v-else></div>
        <!-- 头像裁剪弹窗 -->
        <div class="popup avatar_edit" v-if="isShowAvatarEdit">
            <div class="close position_100" @click="isShowAvatarEdit = false"></div>
            <div class="in">
                <input type="file" ref="file" style="display: none;" @change="getFileData" accept="image/jpg,image/jpeg,image/png"/>
                <div class="btn_group flex">
                    <div class="btn_submit layout_flex_center" @click="$refs.file.click()">上传图片</div>
                    <div class="btn_submit layout_flex_center" @click="closeAvatarEdit">取消</div>
                </div>
                <p class="text">支持jpg、jpeg、png 格式800*800的图片,需小于2M。</p>
                <template v-if="image">
                    <div class="wrapper flex justify_between flex_wrap">
                        <div class="avatar_wrapper">
                            <img class="image" :src="image" ref="image" alt="" @load="cropperInit"/>
                        </div>
                        <div class="avatar_preview" ref="preview"></div>
                    </div>
                    <div class="btn_submit layout_flex_center" @click="uploadAvatar">保存</div>
                </template>
            </div>
        </div>
        <!--  -->
        <div class="form row" :class="{edit: isEdit}">
            <div class="item">
                <p class="name">用户名称：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.username }}</p>
                <template v-else>
                    <input type="text" placeholder="请输入用户名" ref="username" v-model="username"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <div class="item"></div>
            <div class="item">
                <p class="name">电子邮件：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.email }}</p>
                <template v-else>
                    <input type="email" placeholder="请输入邮箱" ref="email" v-model="email"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <div class="item">
                <p class="name">电话号码：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.phone }}</p>
                <template v-else>
                    <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <template v-if="isEdit">
                <div class="item"></div>
                <div class="item">
                    <p class="name">手机验证码：</p>
                    <input class="code" type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="6"/>
                    <div class="btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                    <p class="text r">*</p>
                </div>
            </template>
        </div>
        <!-- 修改按钮 -->
        <div class="flex justify_end btn_bottom_group">
            <template v-if="isEdit">
                <div class="btn_submit layout_flex_center" @click="submit">确认修改</div>
                <div class="btn_submit layout_flex_center" @click="isEdit = false">取消</div>
            </template>
            <div class="btn_submit layout_flex_center" v-else @click="isEdit = true">修改</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.userinfo{
    .avatar_edit{
        .in{
            padding: .6rem 1.2rem;
            .btn_group{
                gap: .2rem;
            }
            .text{
                font-size: .16rem;
                padding: .1rem 0;
            }
            .image{
                width: 100%;
            }
            .wrapper{
                // gap: .2rem;
                margin-bottom: .2rem;
            }
            .avatar_wrapper{
                width: 5rem;
                height: 5rem;
            }
            .avatar_preview{
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                overflow: hidden;
                flex-shrink: 0;
            }
        }
    }
    .avatar{
        width: .9rem;
        height: .9rem;
        margin: 0 auto .6rem;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        &.default{
            background-image: url('~@/assets/images/avatar.jpg');
        }
    }
    .form{
        &.row{
            padding: 0 1rem;
        }
        &.edit{
            padding: 0;
        }
        .item{
            width: calc(50% - .1rem);
        }
    }
}
</style>